import { Model, Make } from '../global/model';

export class Compart {
    public Id = 0;
    public CompartType: CompartType = new CompartType();
    public CompartStr = '';
    public CompartTitle = '';
    public CompartNote = '';
    public MeasurementPointsNo = 1;
    public DefaultBudgetLife = 0;
    public Model: Model = new Model();
    public DefaultMake: Make = new Make();
    public BudgetLife:number;
    public GrouserNum:number;
    public OEMPartNo:string;
    public MFRPartNo:string;
    public HasCleanerHole :number;
    public DefaultDistanceBudget :number;
     public PMUBudgetLife = 0;
    public ComponentPitch?: number;
  }

export class CompartType {
    public Id = 0;
    public Title = '';
    public Order = 1;
}
